import script from "./sidebar-edit-profile-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-edit-profile-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__